import { SvgIcon, SxProps } from "@mui/material";
import Icon from "jsx:../../../Images/Icons/Custom/GameTimeline/rectangle-vertical-solid_yellow.svg";

export function RectangleVerticalSolidYellowIcon(props: SxProps) {
    return <SvgIcon component={Icon} inheritViewBox sx={props} />;
}
